import { StyleSheet, View } from 'react-native';

import { Button, IconRedeem, InlineAlert, Pressable, Text, XStack, YStack, tokens } from '@fhs/ui';
import { formatCentsToDollarString } from '@fhs/utils';

import { StepCardSummaryProps } from './types';

export const StepCardSummary = ({
  cardId,
  balance,
  digitalBalance,
  onChangePress,
  onSave,
  isLoading = false,
}: StepCardSummaryProps) => {
  return (
    <>
      <XStack style={styles.cardIdContainer}>
        <XStack style={styles.cardLeftSideWrapper}>
          <View style={styles.iconContainer}>
            <IconRedeem size={24} color={tokens.colors.$houseDark} />
          </View>
          <Text># {cardId}</Text>
        </XStack>
        <Pressable onPress={onChangePress}>
          <Text style={styles.changeText}>Change</Text>
        </Pressable>
      </XStack>
      <InlineAlert
        type="warning"
        message="The card balance will be added to your digital gift card funds and the physical gift card will be deactivated."
      />
      <YStack style={styles.balanceWrapper}>
        <XStack style={styles.balanceRow}>
          <Text style={styles.balanceText}>Gift Card Balance:</Text>
          <Text style={styles.balanceText}>${formatCentsToDollarString(balance)}</Text>
        </XStack>
        <XStack style={styles.balanceRow}>
          <Text style={styles.balanceText}>Current Digital Balance:</Text>
          <Text style={styles.balanceText}>${formatCentsToDollarString(digitalBalance || 0)}</Text>
        </XStack>
      </YStack>
      <XStack style={styles.newBalanceRow}>
        <Text weight="semibold" style={styles.newBalanceText}>
          New Digital Gift Card Balance:
        </Text>
        <Text weight="semibold" style={styles.newBalanceText}>
          ${formatCentsToDollarString(digitalBalance + balance)}
        </Text>
      </XStack>
      <Button
        style={styles.saveButton}
        size="lg"
        onPress={onSave}
        loading={isLoading}
        disabled={isLoading}
      >
        <Button.Text>Transfer to Digital Gift Card</Button.Text>
      </Button>
    </>
  );
};

const styles = StyleSheet.create({
  cardIdContainer: {
    padding: 16,
    gap: 16,
    marginBottom: 16,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: tokens.colors.$blackOpacity10,
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  cardLeftSideWrapper: {
    alignItems: 'center',
    gap: 16,
  },
  iconContainer: {
    borderRadius: 100,
    backgroundColor: tokens.colors.$blackOpacity04,
    width: 40,
    height: 40,
    justifyContent: 'center',
    alignItems: 'center',
  },
  balanceWrapper: {
    marginTop: 16,
    borderBottomWidth: 1,
    paddingBottom: 16,
    borderColor: tokens.colors.$blackOpacity04,
  },
  balanceRow: {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  balanceText: {
    fontSize: 12,
    lineHeight: 16.8,
  },
  newBalanceRow: {
    marginTop: 16,
    marginBottom: 4,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  newBalanceText: {
    fontSize: 14,
    lineHeight: 19.6,
  },
  changeText: {
    textDecorationLine: 'underline',
    fontSize: 12,
  },
  saveButton: {
    marginTop: 16,
  },
});
